import dayjs from "dayjs"
import type { StaffOption } from "./StaffPickerList"
import type { VehicleOption } from "./VehiclePickerList"

export type CheckStatus = "pass" | "warn" | "fail"

export type CheckKey =
  | "driverStatus"
  | "driverLicense"
  | "vehicleCapacity"
  | "driverBalance"

export interface CheckRow {
  key: CheckKey
  status: CheckStatus
  label: string
  detail?: string
}

export function driverStatusCheck(driver: StaffOption | null): CheckRow {
  if (!driver) {
    return {
      key: "driverStatus",
      status: "warn",
      label: "Жолоочийн төлөв",
      detail: "Жолооч сонгоогүй",
    }
  }
  if (driver.status === "AVAILABLE" || driver.status === "ON_DUTY") {
    return { key: "driverStatus", status: "pass", label: "Жолоочийн төлөв" }
  }
  return {
    key: "driverStatus",
    status: "fail",
    label: "Жолоочийн төлөв",
    detail: driver.status === "SUSPENDED" ? "Зогссон" : "Завгүй",
  }
}

export function driverLicenseCheck(driver: StaffOption | null): CheckRow {
  if (!driver) {
    return {
      key: "driverLicense",
      status: "warn",
      label: "Жолоочийн эрх",
      detail: "Жолооч сонгоогүй",
    }
  }
  if (!driver.licenseExpiresAt) {
    return {
      key: "driverLicense",
      status: "warn",
      label: "Жолоочийн эрх",
      detail: "Эрхийн мэдээлэл алга",
    }
  }
  const valid = dayjs(driver.licenseExpiresAt).isAfter(dayjs())
  return valid
    ? { key: "driverLicense", status: "pass", label: "Жолоочийн эрх" }
    : {
        key: "driverLicense",
        status: "fail",
        label: "Жолоочийн эрх",
        detail: "Хугацаа дууссан",
      }
}

export function vehicleCapacityCheck(
  vehicle: VehicleOption | null,
  requiredSize: number,
): CheckRow {
  if (!vehicle) {
    return {
      key: "vehicleCapacity",
      status: "warn",
      label: "Машины багтаамж",
      detail: "Машин сонгоогүй",
    }
  }
  if (vehicle.maxSize >= requiredSize) {
    return {
      key: "vehicleCapacity",
      status: "pass",
      label: `Машины багтаамж ≥ ${requiredSize}S`,
    }
  }
  return {
    key: "vehicleCapacity",
    status: "fail",
    label: `Машины багтаамж ≥ ${requiredSize}S`,
    detail: `${vehicle.maxSize}S < ${requiredSize}S`,
  }
}

// R-DEL-006 balancing. Backend does not yet expose assigned-delivery counts
// per driver; treat as warn with a TODO until that endpoint lands.
export function driverBalanceCheck(driver: StaffOption | null): CheckRow {
  if (!driver) {
    return {
      key: "driverBalance",
      status: "warn",
      label: "Жолооч хэт хуваарилагдаагүй",
      detail: "Жолооч сонгоогүй",
    }
  }
  // R-DEL-006 — backend does not yet expose assigned-delivery counts.
  // Return warn (not pass) so we never falsely claim the rule is satisfied.
  return {
    key: "driverBalance",
    status: "warn",
    label: "Жолооч хэт хуваарилагдаагүй",
    detail: "Шалгалт хүлээгдэж байна",
  }
}
